import { eventsDuck } from '@eb/redux-destination';

export const loggedOutSaveRedirect = (eventId: string) => {
    eventsDuck.api.loggedOutSaveRedirect(eventId, {
        pathname: window.location.pathname,
    });
};

export const parseFollowSignalExperimentVariants = (
    organizerFollowCount: number,
    followSignalExperimentVariant?: string,
) => {
    if (followSignalExperimentVariant === 'B' && organizerFollowCount >= 10) {
        return {
            signal: { type: 'follow', value: organizerFollowCount },
        };
    }

    if (followSignalExperimentVariant === 'C' && organizerFollowCount > 0) {
        return {
            signal: { type: 'follow', value: organizerFollowCount },
        };
    }

    return {};
};
